import React from 'react'
import { Link } from 'react-router-dom'
import { Badge } from '../ui/badge'

function CoinCategories({ categories }) {
  if (!categories || !categories.length) {
    return null
  }

  return (
    <div className="flex items-center gap-2 mt-4 flex-wrap">
      <span className="text-sm text-walme-text-dim">Categories:</span>
      {categories.map((category, i) => (
        <Link key={i} to={`/discovery/${category}`}>
          <Badge variant="outline" className="capitalize hover:bg-walme-bg-elevated-2 transition-colors">
            {category}
          </Badge>
        </Link>
      ))}
    </div>
  )
}

export default CoinCategories
